var _ellipse, _path, _rect, _g, _g2, _g3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _circle, _circle2, _g4, _rect2, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _g5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 386,
    viewBox: "0 0 512 386",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.05,
    cx: 263.97,
    cy: 168.198,
    rx: 263.97,
    ry: 168.198,
    transform: "matrix(-0.915086 -0.403258 -0.403298 0.915069 567.264 148.55)",
    fill: "#72A4FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M472 367.071H34V368.328H472V367.071Z",
    fill: "#8C7C5F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 34,
    width: 270,
    height: 174,
    rx: 6,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1508_40343)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 79,
    width: 190.5,
    height: 27.4,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 85,
    width: 27.5,
    height: 15.4,
    rx: 7.7,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.65,
    y: 86.65,
    width: 12.1,
    height: 12.1,
    rx: 6.05,
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.5 91.2C281.5 90.6477 281.052 90.2 280.5 90.2H226.5C225.948 90.2 225.5 90.6477 225.5 91.2V94.2C225.5 94.7523 225.948 95.2 226.5 95.2H280.5C281.052 95.2 281.5 94.7523 281.5 94.2V91.2Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.5 91.2C303.5 90.6477 303.052 90.2 302.5 90.2H288.5C287.948 90.2 287.5 90.6477 287.5 91.2V94.2C287.5 94.7523 287.948 95.2 288.5 95.2H302.5C303.052 95.2 303.5 94.7523 303.5 94.2V91.2Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.5 91.2C326.5 90.6477 326.052 90.2 325.5 90.2H310.5C309.948 90.2 309.5 90.6477 309.5 91.2V94.2C309.5 94.7523 309.948 95.2 310.5 95.2H325.5C326.052 95.2 326.5 94.7523 326.5 94.2V91.2Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.5 91.2C348.5 90.6477 348.052 90.2 347.5 90.2H333.5C332.948 90.2 332.5 90.6477 332.5 91.2V94.2C332.5 94.7523 332.948 95.2 333.5 95.2H347.5C348.052 95.2 348.5 94.7523 348.5 94.2V91.2Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.5 91.2C370.5 90.6477 370.052 90.2 369.5 90.2H355.5C354.948 90.2 354.5 90.6477 354.5 91.2V94.2C354.5 94.7523 354.948 95.2 355.5 95.2H369.5C370.052 95.2 370.5 94.7523 370.5 94.2V91.2Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.25,
    y: 79.25,
    width: 190,
    height: 26.9,
    rx: 3.75,
    stroke: "#F2F2F2",
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1508_40343)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 116.4,
    width: 190.5,
    height: 27.4,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 122.4,
    width: 27.5,
    height: 15.4,
    rx: 7.7,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.65,
    y: 124.05,
    width: 12.1,
    height: 12.1,
    rx: 6.05,
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.5 128.6C281.5 128.048 281.052 127.6 280.5 127.6H226.5C225.948 127.6 225.5 128.048 225.5 128.6V131.6C225.5 132.152 225.948 132.6 226.5 132.6H280.5C281.052 132.6 281.5 132.152 281.5 131.6V128.6Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.5 128.6C303.5 128.048 303.052 127.6 302.5 127.6H288.5C287.948 127.6 287.5 128.048 287.5 128.6V131.6C287.5 132.152 287.948 132.6 288.5 132.6H302.5C303.052 132.6 303.5 132.152 303.5 131.6V128.6Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.5 128.6C326.5 128.048 326.052 127.6 325.5 127.6H310.5C309.948 127.6 309.5 128.048 309.5 128.6V131.6C309.5 132.152 309.948 132.6 310.5 132.6H325.5C326.052 132.6 326.5 132.152 326.5 131.6V128.6Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.5 128.6C348.5 128.048 348.052 127.6 347.5 127.6H333.5C332.948 127.6 332.5 128.048 332.5 128.6V131.6C332.5 132.152 332.948 132.6 333.5 132.6H347.5C348.052 132.6 348.5 132.152 348.5 131.6V128.6Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.5 128.6C370.5 128.048 370.052 127.6 369.5 127.6H355.5C354.948 127.6 354.5 128.048 354.5 128.6V131.6C354.5 132.152 354.948 132.6 355.5 132.6H369.5C370.052 132.6 370.5 132.152 370.5 131.6V128.6Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.25,
    y: 116.65,
    width: 190,
    height: 26.9,
    rx: 3.75,
    stroke: "#F2F2F2",
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1508_40343)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 153.8,
    width: 190.5,
    height: 27.4,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 159.8,
    width: 27.5,
    height: 15.4,
    rx: 7.7,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.65,
    y: 161.45,
    width: 12.1,
    height: 12.1,
    rx: 6.05,
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.5 166C281.5 165.448 281.052 165 280.5 165H226.5C225.948 165 225.5 165.448 225.5 166V169C225.5 169.552 225.948 170 226.5 170H280.5C281.052 170 281.5 169.552 281.5 169V166Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.5 166C303.5 165.448 303.052 165 302.5 165H288.5C287.948 165 287.5 165.448 287.5 166V169C287.5 169.552 287.948 170 288.5 170H302.5C303.052 170 303.5 169.552 303.5 169V166Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.5 166C326.5 165.448 326.052 165 325.5 165H310.5C309.948 165 309.5 165.448 309.5 166V169C309.5 169.552 309.948 170 310.5 170H325.5C326.052 170 326.5 169.552 326.5 169V166Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.5 166C348.5 165.448 348.052 165 347.5 165H333.5C332.948 165 332.5 165.448 332.5 166V169C332.5 169.552 332.948 170 333.5 170H347.5C348.052 170 348.5 169.552 348.5 169V166Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.5 166C370.5 165.448 370.052 165 369.5 165H355.5C354.948 165 354.5 165.448 354.5 166V169C354.5 169.552 354.948 170 355.5 170H369.5C370.052 170 370.5 169.552 370.5 169V166Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.25,
    y: 154.05,
    width: 190,
    height: 26.9,
    rx: 3.75,
    stroke: "#F2F2F2",
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146 40C146 36.6863 148.686 34 152 34H410C413.314 34 416 36.6863 416 40V62H146V40Z",
    fill: "#6E6E6E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M159.999 52.1154C162.209 52.1154 164 50.3244 164 48.1153C164 45.9062 162.209 44.1154 159.999 44.1154C157.79 44.1154 156 45.9062 156 48.1153C156 50.3244 157.79 52.1154 159.999 52.1154Z",
    fill: "#FFA9A9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M174.001 52C176.21 52 178 50.2091 178 47.9999C178 45.7908 176.21 44 174.001 44C171.791 44 170 45.7908 170 47.9999C170 50.2091 171.791 52 174.001 52Z",
    fill: "#FFD08A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M187.999 52.1154C190.209 52.1154 192 50.3244 192 48.1153C192 45.9062 190.209 44.1154 187.999 44.1154C185.79 44.1154 184 45.9062 184 48.1153C184 50.3244 185.79 52.1154 187.999 52.1154Z",
    fill: "#BBEEB6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.039 343.742L101.028 352.713L99.2516 360.647H89.1621L90.2683 350.906L91.0728 343.575L103.039 343.742Z",
    fill: "#F0DCCF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5992 357.199C90.4707 358.102 94.0908 361.148 100.024 357.031C100.091 356.997 100.158 356.997 100.191 357.031L116.583 365.802C117.353 366.203 117.052 367.375 116.18 367.375H89.3981C88.1578 367.375 87.2528 366.236 87.5209 365.032L89.264 357.333C89.3645 357.165 89.5321 357.098 89.5992 357.199Z",
    fill: "#8C7C5F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5992 357.199C89.955 357.568 90.7691 358.294 92.0119 358.744L91.4133 364.603C90.8807 366.201 94.0765 366.201 116.18 367.375C116.951 367.777 117.052 367.375 116.18 367.375H89.3981C88.1578 367.375 87.2528 366.236 87.5209 365.032L89.264 357.333C89.3645 357.165 89.5321 357.098 89.5992 357.199Z",
    fill: "#776546"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M134.549 343.742L132.739 353.617L131.431 360.647H121.342L122.079 350.739L122.582 343.575L134.549 343.742Z",
    fill: "#F0DCCF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M103.041 343.741L101.029 352.713C96.3319 354.099 92.231 352.713 90.2695 350.905L91.074 343.575L103.041 343.741Z",
    fill: "#D7BDAD"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M134.548 343.741L133.643 348.679L133.191 351.148L132.965 352.382C128.228 353.644 123.671 352.732 122.079 350.738L122.582 343.575L134.548 343.741Z",
    fill: "#D7BDAD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M121.774 357.199C122.645 358.102 126.131 361.148 132.064 357.031C132.131 356.997 132.198 356.997 132.232 357.031L148.622 365.802C149.393 366.203 149.092 367.375 148.221 367.375H121.573C120.332 367.375 119.427 366.236 119.696 365.032L121.439 357.333C121.539 357.165 121.707 357.098 121.774 357.199Z",
    fill: "#8C7C5F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M121.774 357.199C122.13 357.568 122.944 358.294 124.186 358.744L123.588 364.603C123.055 366.201 126.251 366.201 148.355 367.375C149.126 367.777 149.226 367.375 148.355 367.375H121.573C120.332 367.375 119.427 366.236 119.696 365.032L121.439 357.333C121.539 357.165 121.707 357.098 121.774 357.199Z",
    fill: "#776546"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M113.632 91.9755C113.632 91.9755 114.604 95.5238 115.442 97.8336C116.28 100.143 118.626 99.3065 118.626 99.3065L118.593 93.2475L113.632 91.9755Z",
    fill: "#643A0C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M129.286 104.462C129.286 104.496 129.286 104.496 129.286 104.462C129.454 105.969 129.588 107.207 129.722 108.245C130.258 112.262 130.761 113.969 132.102 119.225L114.638 120.899L116.347 96.0935C115.912 95.5245 109.174 88.8294 114.772 87.2227C114.772 87.2227 112.928 74.4017 122.951 74.9038C132.973 75.4059 136.694 81.7997 136.694 81.7997C136.694 81.7997 142.693 107.241 129.286 104.462Z",
    fill: "#F0DCCF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M114.672 74.1334C114.672 74.1334 120.638 63.0197 134.382 73.4974C135.588 74.4347 136.795 74.2673 139.476 75.5058C141.789 76.5771 142.058 79.8241 139.945 81.2301C136.761 83.3725 132.84 84.5776 124.828 81.1632C128.348 84.4772 134.147 84.3433 134.147 84.3433C122.717 85.4815 120.37 80.8954 120.236 80.7949C120.236 80.7949 121.623 85.7669 118.204 89.8175C118.204 89.8175 117.789 88.762 116.884 88.0591C115.711 87.1552 113.7 86.9209 112.627 88.9294C112.594 88.9628 106.326 77.2131 114.672 74.1334Z",
    fill: "#794A15"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M114.672 74.1334C114.672 74.1334 120.638 63.0197 134.382 73.4974C134.382 73.4974 130.507 73.4138 125.95 72.5024C125.95 72.5024 119.345 71.4553 115.926 75.5058C115.926 75.5058 117.748 78.8817 115.926 80.7043C112.736 83.4382 114.672 87.5392 114.672 87.5392C114.103 87.5392 113.336 87.6023 112.627 88.9294C112.594 88.9628 106.326 77.2131 114.672 74.1334Z",
    fill: "#643A0C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M117.681 89.2306L123.136 88.2264C123.605 86.9878 124.745 86.0839 126.119 85.9165C127.996 85.7158 129.672 86.9878 130.007 88.7955L131.985 88.5946C131.952 86.7535 133.359 85.1801 135.203 84.9792C137.18 84.7784 138.957 86.2178 139.159 88.1929C139.359 90.1679 137.919 91.9421 135.94 92.1429C134.063 92.3438 132.387 91.0718 132.052 89.2641L130.075 89.4649C130.108 91.3061 128.7 92.8794 126.857 93.0802C124.879 93.2811 123.102 91.8416 122.901 89.8666C122.868 89.5319 122.868 89.1972 122.935 88.8959L118.203 89.8175L117.681 89.2306ZM135.907 91.5069C137.516 91.3395 138.69 89.9001 138.522 88.2933C138.354 86.6865 136.912 85.5149 135.304 85.6822C133.695 85.8496 132.522 87.2891 132.689 88.8959C132.823 90.5026 134.298 91.6743 135.907 91.5069ZM126.79 92.4442C128.399 92.2768 129.572 90.8375 129.404 89.2306C129.236 87.6238 127.795 86.4522 126.186 86.6195C124.577 86.7869 123.404 88.2263 123.572 89.8332C123.706 91.4399 125.181 92.6116 126.79 92.4442Z",
    fill: "#222222"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M159.118 205.322L157.644 217.808L156.436 228.052L153.386 253.693L138.335 349.265C129.139 351.366 121.392 350.91 117.747 345.442C118.979 330.598 122.213 289.813 122.213 289.813C123.889 268.891 124.861 221.558 124.861 221.558L124.794 217.374L124.392 195.213V194.275L127.911 195.38L143.163 200.234L159.118 205.322Z",
    fill: "#CEC9C0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M158.757 209.656L138.708 201.909L123.672 267.98L120.026 315.824C125.646 302.154 125.829 277.326 140.987 259.322C145.607 253.835 154.201 246.564 154.201 246.564L158.757 209.656Z",
    fill: "#ACA18C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M144.201 194.276L143.866 196.217L143.162 200.235L140.514 215.332L140.414 215.834L138.704 225.609L134.983 249.51C134.815 250.381 132.536 258.649 132.301 259.519L108.234 349.266C98.6095 353.188 88.3753 350.323 87 346.337L87.5527 343.408L88.6588 337.55L90.8711 325.833L95.2957 302.401L104.145 255.535L104.245 215.567V215.499V209.373L105.586 194.276H144.201Z",
    fill: "#CEC9C0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3314 148.597C95.6024 149.327 94.8126 148.597 94.5088 148.142C94.5088 146.775 94.7067 147.033 94.9644 146.775C95.4201 146.319 95.8758 146.319 96.3314 146.319C96.6352 146.775 97.0605 147.868 96.3314 148.597Z",
    fill: "#3865B5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M160.393 209.239L160.46 209.641C160.158 209.709 159.856 209.775 159.588 209.809C149.264 211.817 142.057 203.315 130.024 206.494C128.918 206.796 127.812 207.164 126.605 207.666C122.331 209.482 118.182 210.177 114.558 210.111C112.163 210.068 109.998 209.62 108.179 209.2C102.727 207.899 99.9774 205.555 99.9774 205.555L101.164 188.953L101.566 182.325L101.935 176.3L102.102 173.287L102.471 166.961L102.711 162.723L103.074 157.152L116.381 157.711L115.925 154.065L114.103 154.977L109.546 147.686L109.091 143.585C103.623 141.763 94.5095 144.952 94.5095 148.142L91.8116 129.067C91.4764 124.949 93.6217 120.999 97.3088 119.058L115.074 110.354C127.141 118.288 130.058 109.551 130.058 109.551L147.119 113.3C150.27 113.936 152.918 116.012 154.359 118.89L163.443 140.683L150.606 143.327L152.65 157.186L153.622 163.646L155.499 176.3L158.448 197.624L159.455 203.616L160.393 209.139V209.239Z",
    fill: "#9AADFF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M102.711 162.723L99.9766 205.555C101.799 207.377 107.723 210.111 114.558 210.111C110.545 192.444 110.001 179.127 110.457 166.368L102.711 162.723Z",
    fill: "#778BE1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M106.356 139.484L110.457 147.686L115.47 153.61L118.204 149.053C117.596 148.445 115.925 146.684 114.103 144.496C112.28 142.309 108.179 140.244 106.356 139.484Z",
    fill: "#778BE1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M154.928 172.55L125.096 167.998L122.85 167.663L117.018 166.76L118.727 158.156L129.139 158.166L148.56 158.524L147.365 150.876L146.347 145.402L146.046 143.728L159.789 141.385L159.99 144.8L161.196 166.693C161.498 170.207 158.415 173.053 154.928 172.55Z",
    fill: "#F0DCCF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M129.139 158.166C128.227 161.356 125.038 165.913 122.85 167.629L117.018 166.725L118.727 158.123L129.139 158.166Z",
    fill: "#D7BDAD"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M155.063 119.091L144.303 125.953C143.934 126.188 143.465 126.322 143.029 126.322H138.336C138.336 126.322 125.364 169.471 115.208 172.885C111.015 174.288 106.656 169.193 102.711 162.723C100.253 158.692 97.5972 153.57 96.3362 150.858C95.5318 149.085 95.0625 147.98 95.0625 147.98C103.005 143.193 105.971 142.589 109.174 145.436L109.61 146.273L114.537 155.478L128.951 130.004C128.951 130.004 131.633 125.518 131.968 124.983C132.906 123.443 133.945 121.602 134.984 120.296C136.828 118.02 140.113 117.785 141.689 117.953C142.124 117.986 142.392 119.057 142.023 119.292L139.677 120.296C139.677 120.296 146.75 120.095 151.074 117.953C153.085 116.949 154.191 117.518 155.063 118.087C155.431 118.321 155.431 118.857 155.063 119.091Z",
    fill: "#F0DCCF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M114.403 152.499C114.403 151.16 113.197 150.792 113.197 150.792C113.599 149.587 111.99 149.085 111.99 149.085C110.649 147.745 105.856 147.511 104.146 148.717C102.437 149.922 105.219 150.826 105.219 150.826C104.649 153.001 107.163 152.767 107.163 152.767C107.163 152.767 106.124 154.575 108.839 154.775C108.638 154.977 108.671 155.713 109.509 156.115C110.984 156.851 114.537 154.441 114.537 154.441C115.711 153.47 114.403 152.499 114.403 152.499Z",
    fill: "#F0DCCF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M110.213 156.75C109.878 156.75 109.577 156.683 109.308 156.549C108.739 156.282 108.37 155.812 108.269 155.31C108.269 155.277 108.269 155.244 108.236 155.176C107.431 155.042 106.895 154.708 106.627 154.206C106.459 153.871 106.426 153.503 106.459 153.201C105.99 153.135 105.387 152.967 105.018 152.499C104.716 152.131 104.582 151.661 104.649 151.093C104.079 150.858 103.208 150.356 103.107 149.62C103.04 149.285 103.141 148.75 103.878 148.247C105.755 146.942 110.683 147.176 112.292 148.582C112.459 148.648 112.794 148.782 113.096 149.05C113.599 149.452 113.834 149.954 113.8 150.457C114.236 150.724 114.839 151.227 114.94 152.231C115.174 152.465 115.577 152.901 115.577 153.503C115.577 153.838 115.476 154.34 114.906 154.808L114.873 154.842C114.303 155.21 111.923 156.75 110.213 156.75ZM109.241 155.076C109.241 155.176 109.308 155.444 109.744 155.678C110.582 156.114 112.862 154.976 114.236 154.038C114.437 153.871 114.537 153.704 114.537 153.57C114.537 153.269 114.202 152.967 114.102 152.933L113.901 152.8V152.532C113.901 151.595 113.13 151.327 113.029 151.293L112.56 151.126L112.694 150.657C112.929 149.954 111.856 149.586 111.822 149.552L111.722 149.52L111.621 149.452C110.448 148.28 105.923 148.08 104.415 149.151C104.113 149.352 104.046 149.486 104.079 149.552C104.113 149.787 104.817 150.222 105.353 150.39L105.789 150.524L105.688 150.992C105.588 151.427 105.621 151.729 105.789 151.963C106.091 152.331 106.861 152.365 107.13 152.331L108.102 152.265L107.632 153.101C107.632 153.101 107.398 153.536 107.565 153.838C107.699 154.105 108.202 154.306 108.906 154.34L109.945 154.407L109.241 155.076Z",
    fill: "#D7BDAD"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M109.545 145.863C106.811 143.585 96.3241 147.686 96.3311 150.876C95.3385 149.114 94.0539 147.686 95.4203 146.319C98.1532 143.585 104.989 141.307 108.178 143.13L109.545 145.863Z",
    fill: "#D7BDAD"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M159.838 142.238C153.289 142.674 148.276 145.408 147.365 150.876L145.998 143.585C147.926 141.595 154.2 139.94 159.788 141.384L159.838 142.238Z",
    fill: "#D7BDAD"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M129.722 108.244C124.158 105.934 121.979 99.7416 121.912 99.5408C123.655 101.917 127.61 103.892 130.292 104.16C130.359 104.729 129.588 104.629 129.488 105.198C129.253 106.102 129.622 107.608 129.722 108.244Z",
    fill: "#D7BDAD"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M114.102 87.5391C116.289 86.8101 117.747 88.7542 118.203 89.8174L116.836 96.1966C115.773 95.1334 113.555 92.8247 113.191 92.0957L113.191 92.0957C112.735 91.1844 111.368 88.4504 114.102 87.5391Z",
    fill: "#F0DCCF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M145.998 143.585L144.385 135.114C144.273 134.701 144.207 134.324 144.176 134.016L144.385 135.114C144.823 136.737 145.951 138.903 148.277 139.484C151.193 140.213 154.352 140.699 155.567 140.851C153.289 140.851 148.186 141.398 145.998 143.585Z",
    fill: "#778BE1"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M125.95 81.6157C122.335 80.1699 121.393 77.5147 120.482 76.6034C119.193 75.3146 117.292 74.9326 116.381 75.2364C120.937 72.0468 123.598 77.1623 125.494 78.426C128.228 80.2486 128.944 80.9757 132.785 81.6156C135.519 82.0712 138.86 81.7675 140.075 81.16C139.619 81.4637 138.252 82.5269 136.43 82.9826C135.222 83.2845 133.316 83.6941 131.418 83.4382C129.573 83.1895 128.228 82.5269 125.95 81.6157Z",
    fill: "#643A0C"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M325.006 163.005C346.545 163.005 364.006 145.544 364.006 124.005C364.006 102.466 346.545 85.0052 325.006 85.0052C303.467 85.0052 286.006 102.466 286.006 124.005C286.006 145.544 303.467 163.005 325.006 163.005ZM325.501 155C342.898 155 357.001 141.121 357.001 124C357.001 106.879 342.898 93.0001 325.501 93.0001C308.104 93.0001 294.001 106.879 294.001 124C294.001 141.121 308.104 155 325.501 155Z",
    fill: "#9AADFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 326,
    cy: 124,
    r: 31,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1508_40343",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 294,
    y: 93,
    width: 63,
    height: 63
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.54,
    cy: 124.005,
    r: 31,
    transform: "rotate(-9.16084 325.54 124.005)",
    fill: "#B5B5B5"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1508_40343)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1508_40343)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 193,
    y: 73,
    width: 190.5,
    height: 27.4,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.25,
    y: 73.25,
    width: 190,
    height: 26.9,
    rx: 3.75,
    stroke: "#F2F2F2",
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1508_40343)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 193,
    y: 110.4,
    width: 330.5,
    height: 27.4,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.5 121.7C347.5 120.816 346.241 120.1 344.688 120.1H305.313C303.759 120.1 302.5 120.816 302.5 121.7V126.5C302.5 127.384 303.759 128.1 305.313 128.1H344.688C346.241 128.1 347.5 127.384 347.5 126.5V121.7Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.25,
    y: 110.65,
    width: 330,
    height: 26.9,
    rx: 3.75,
    stroke: "#F2F2F2",
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_1508_40343)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 193,
    y: 147.8,
    width: 190.5,
    height: 27.4,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.25,
    y: 148.05,
    width: 190,
    height: 26.9,
    rx: 3.75,
    stroke: "#F2F2F2",
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 356.98,
    y: 152.94,
    width: 10,
    height: 10,
    transform: "rotate(-54.1608 356.98 152.94)",
    fill: "#778BE1"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M365.783 162.234C364.26 160.868 364.014 158.573 365.212 156.914L369.195 151.399C370.393 149.741 372.649 149.253 374.425 150.269L428.904 181.451C433.949 183.861 433.16 190.076 427.598 197.777C421.743 205.884 415.865 207.19 412.51 204.15L365.783 162.234Z",
    fill: "#9AADFF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M351.17 152.445L360.538 139.474C363.224 141.415 363.829 145.165 361.889 147.851L359.547 151.094C357.607 153.78 353.856 154.385 351.17 152.445Z",
    fill: "#9AADFF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M338.6 254.501L329.21 293.517C328.962 294.497 328.052 295.204 326.977 295.204H274.483C272.994 295.204 271.919 293.909 272.25 292.537L281.639 253.521C281.887 252.541 282.797 251.835 283.873 251.835H336.367C337.814 251.835 338.89 253.13 338.6 254.501Z",
    fill: "#C7C7C7"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M238 291.087H279.2V295.204H238V291.087Z",
    fill: "#C7C7C7"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M341.703 254.345L332.313 293.478C332.066 294.458 331.155 295.165 330.08 295.165H277.586C276.098 295.165 275.021 293.87 275.353 292.498L284.743 253.364C284.991 252.384 285.901 251.679 286.976 251.679H339.47C340.959 251.679 342.035 252.973 341.703 254.345Z",
    fill: "#E6E6E6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.791 303.025C325.583 301.231 328.215 301.531 328.584 303.457L336.302 343.761L351.378 303.148C351.718 302.233 352.891 301.977 353.581 302.667C353.893 302.979 354.031 303.424 353.951 303.858L342.45 365.961C342.047 368.136 338.935 368.145 338.519 365.973L335.685 351.172L329.956 366.604C329.292 368.391 326.741 368.324 326.172 366.504L314.884 330.383L307.535 347.009L307.92 365.652C307.963 367.711 305.241 368.483 304.197 366.708L301.131 361.496L298.789 366.795C297.982 368.62 295.294 368.268 294.984 366.296L291.714 345.487L279.721 325.098L268.748 366.321C268.251 368.186 265.663 368.336 264.955 366.541L257.032 346.461L252.151 366.415C251.632 368.536 248.576 368.41 248.233 366.254L238.445 304.674C238.07 302.313 241.404 301.402 242.281 303.626L256.583 339.876L265.443 303.654C265.87 301.91 268.2 301.568 269.11 303.115L279.019 319.96L283.315 303.821C283.871 301.732 286.887 301.889 287.223 304.025L293.631 344.8L300.878 357.121L305.526 346.607L304.646 304.059C304.598 301.745 307.864 301.212 308.554 303.422L315.206 324.708L324.791 303.025ZM316.112 327.606L328.081 365.908L334.959 347.38L326.62 303.833L316.112 327.606ZM313.979 327.485L306.645 304.018L307.437 342.284L313.979 327.485ZM305.624 351.333L302.127 359.244L305.921 365.694L305.624 351.333ZM299.883 359.373L294.476 350.183L296.96 365.986L299.883 359.373ZM290.868 340.104L285.247 304.336L280.444 322.382L290.868 340.104ZM278.296 322.676L267.386 304.129L257.855 343.097L266.815 365.807L278.296 322.676ZM255.761 343.239L240.421 304.36L250.208 365.94L255.761 343.239ZM337.028 347.553L340.483 365.597L350.591 311.016L337.028 347.553Z",
    fill: "#AAAAAA"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M362 295H227V303H362V295Z",
    fill: "#999085"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M333.433 254.525C334.508 259.984 336.804 266.659 341.159 274.682L344.471 274.449C344.471 274.449 344.351 271.869 344.023 268.024C343.218 257.804 341.099 238.528 336.595 234C336.595 234 330.569 239.926 333.433 254.525Z",
    fill: "#AACCA7"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M333.448 254.341C334.521 259.851 336.815 266.587 341.164 274.683L344.471 274.447C344.471 274.447 344.351 271.844 344.024 267.964C343.273 259.626 338.092 255.561 333.448 254.341Z",
    fill: "#5B9356"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M343.683 274.095C343.683 274.095 331.857 256.263 324.47 251.851C324.47 251.851 319.606 262.805 341.159 274.683L343.683 274.095Z",
    fill: "#AACCA7"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M343.683 274.092C343.683 274.092 342.536 272.39 340.729 269.906C336.744 264.837 330.559 262.395 326.362 262.663C328.789 266.24 333.213 270.402 341.106 274.682L343.683 274.092Z",
    fill: "#5B9356"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M364.496 240.227C364.496 240.227 345.467 254.873 343.683 274.682H344.352C344.352 274.682 368.481 253.354 364.496 240.227Z",
    fill: "#AACCA7"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M364.496 240.227C364.496 240.227 359.322 245.782 353.223 255.421C349.865 260.729 347.652 266.161 343.683 274.682H344.352C344.352 274.682 368.481 253.354 364.496 240.227Z",
    fill: "#5B9356"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M328.725 273.257L330.159 279.05L334.238 295.281H349.948L355.493 273.257H328.725Z",
    fill: "#9AADFF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M330.299 279.186L334.15 295.281H344.471C338.582 292.653 335.523 289.045 330.299 279.186Z",
    fill: "#778BE1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1508_40343",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 238,
    y: 301,
    width: 116,
    height: 67
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.791 303.025C325.583 301.231 328.215 301.531 328.584 303.457L336.302 343.761L351.378 303.148C351.718 302.233 352.891 301.977 353.581 302.667C353.893 302.979 354.031 303.424 353.951 303.858L342.45 365.961C342.047 368.136 338.935 368.145 338.519 365.973L335.685 351.172L329.956 366.604C329.292 368.391 326.741 368.324 326.172 366.504L314.884 330.383L307.535 347.009L307.92 365.652C307.963 367.711 305.241 368.483 304.197 366.708L301.131 361.496L298.789 366.795C297.982 368.62 295.294 368.268 294.984 366.296L291.714 345.487L279.721 325.098L268.748 366.321C268.251 368.186 265.663 368.336 264.955 366.541L257.032 346.461L252.151 366.415C251.632 368.536 248.576 368.41 248.233 366.254L238.445 304.674C238.07 302.313 241.404 301.402 242.281 303.626L256.583 339.876L265.443 303.654C265.87 301.91 268.2 301.568 269.11 303.115L279.019 319.96L283.315 303.821C283.871 301.732 286.887 301.889 287.223 304.025L293.631 344.8L300.878 357.121L305.526 346.607L304.646 304.059C304.598 301.745 307.864 301.212 308.554 303.422L315.206 324.708L324.791 303.025ZM316.112 327.606L328.081 365.908L334.959 347.38L326.62 303.833L316.112 327.606ZM313.979 327.485L306.645 304.018L307.437 342.284L313.979 327.485ZM305.624 351.333L302.127 359.244L305.921 365.694L305.624 351.333ZM299.883 359.373L294.476 350.183L296.96 365.986L299.883 359.373ZM290.868 340.104L285.247 304.336L280.444 322.382L290.868 340.104ZM278.296 322.676L267.386 304.129L257.855 343.097L266.815 365.807L278.296 322.676ZM255.761 343.239L240.421 304.36L250.208 365.94L255.761 343.239ZM337.028 347.553L340.483 365.597L350.591 311.016L337.028 347.553Z",
    fill: "#AAAAAA"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1508_40343)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 297,
    width: 128,
    height: 16,
    fill: "#888888"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1508_40343",
    x: 182,
    y: 79,
    width: 198.5,
    height: 35.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1508_40343"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1508_40343",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1508_40343",
    x: 182,
    y: 116.4,
    width: 198.5,
    height: 35.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1508_40343"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1508_40343",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1508_40343",
    x: 182,
    y: 153.8,
    width: 198.5,
    height: 35.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1508_40343"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1508_40343",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1508_40343",
    x: 189,
    y: 73,
    width: 198.5,
    height: 35.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1508_40343"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1508_40343",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1508_40343",
    x: 189,
    y: 110.4,
    width: 338.5,
    height: 35.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1508_40343"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1508_40343",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_1508_40343",
    x: 189,
    y: 147.8,
    width: 198.5,
    height: 35.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1508_40343"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1508_40343",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.ef07d6b5438569ce2409302a2be8055a.svg";
export { ForwardRef as ReactComponent };